/* This is a generated file. Do not edit manually. */
import React from 'react';
import PropTypes from 'prop-types';
import iconSizes from '../../iconSizes';

/**
 * MinusIcon
 */
export default class MinusIcon extends React.Component {
  static propTypes = {
    /** The size of the icon */
    size: PropTypes.oneOf(['s', 'm', 'l', 'xl']),
    /** The color of the icon */
    color: PropTypes.string.isRequired
  };

  static defaultProps = {
    size: 'm',
    color: 'black'
  };

  render() {
    const { size: sizeProp, color } = this.props;
    const size = correctButtonSize(sizeProp);
    return (
      <svg
        focusable="false"
        xmlns="http://www.w3.org/2000/svg"
        viewBox={'0 0 32 32'}
        style={{ width: iconSizes[size], height: iconSizes[size] }}
      >
        <g style={{ fill: color }}>
          <svg viewBox="0 0 24 24"><path d="M19 11H5c-.6 0-1 .4-1 1s.4 1 1 1h14c.6 0 1-.4 1-1s-.4-1-1-1z"/><g fillRule="evenodd"><use/><use fillRule="nonzero"/></g></svg>
        </g>
      </svg>
    );
  }
}

/* corrects deprecated api, can be removed in future release */
function correctButtonSize(size) {
  switch (size) {
    case 'medium':
      return 'm';
    case 'small':
      return 's';
    case 'large':
      return 'l';
    case 'xlarge':
      return 'xl';
    default:
      return size;
  }
}

